import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { fuseAnimations } from '@fuse/animations';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { IdiomasServiceN35 } from 'app/main/wizard-n35/services/idiomas.service';
import * as backInter from 'app/auth/auth-data.model';
import * as colabInter from 'app/main/pagina/encuestador-n35/colaboradores35/colaboradores35.interface';
// HERE
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import *  as $ from 'jquery';
///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { WizardService } from './services/wizard.service';
import { ColaboradoresEncuestadorService } from 'app/main/wizard-n35encuestador/services/colaboradoresEncuestador.service';
import { datosArbol, datosArbolBetter, datosArbol_50masBetter } from './wizard-n35.tree';
import { datosArbol_50mas } from './wizard-n35.tree';
interface FoodNode {
  name: string,
  ruta: string,
  status: any,
  seccion: string,
  pos:number,
  children?: FoodNode[]
}
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
}


@Component({
  selector: 'wizard-n35',
  templateUrl: './wizard-n35.component.html',
  styleUrls: ['./wizard-n35.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations   : fuseAnimations
})
export class WizardN35Component{
  statusEncuesta=false;// false igual a menos de 50 / true más de 50
  currentStep: number;
  mensajeEntreComponents: string;
  arbolDocumentador: any;
  arbolDocumentadorSecond: any;
  arbolCargado = false;
  ArrayMenu: Array<any> = [];
  ArrayMenu_Child: Array<any> = [];
  treeControl:any;
  treeFlattener:any;
  dataSourceTree:any;
  Step_Select = 0;
  productoCertificar: backInter.prodNorma35;
  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
  fechaDocumentador_P:any;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _fuseSidebarService: FuseSidebarService,
    private idiomasService: IdiomasServiceN35,
    private wizardService: WizardService,
    private colaboradoresService: ColaboradoresEncuestadorService,
  )
  {
    // ESTAS DOS VARIABLES SON LOS ARREGLOS PARA LOS MENÚ
    //this.arbolDocumentador = datosArbol;
    //this.arbolDocumentadorSecond = datosArbol_50mas;
    // FIN ARREGLO MENÚ
    this.currentStep = 0;
    this.wizardService.mensajeActual.subscribe( (resu) => {
      this.mensajeEntreComponents = resu;
      switch(this.mensajeEntreComponents){
        case "100": 
        this.getColaboradoresFast();
        break;
      }
    });
    this.obtieneCertificarActual();
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }
  ngOnInit(): void
  {
    $('html, body').animate({
			scrollTop: ($('#course-step-content').offset().top)
		},1100);
  }

  gotoStep(step): void
  {
    this.currentStep = step;
  }
  step_selected(valor):void{
    this.Step_Select=valor;
  }

  toggleSidebar(name): void
  {
    this._fuseSidebarService.getSidebar(name).toggleOpen();
  }
  typeContent:any;
 obtieneCertificarActual(){
   console.log("Obtener actual");

    this.wizardService.getProdCertAct().subscribe((data:backInter.infoProductos) => {

      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
        prodsCertificar.forEach( (producto) => {
          if(producto.completoNorma35 === 1){
            
            this.productoCertificar = producto;
            this.typeContent=this.productoCertificar.tipo;
            if(this.typeContent){

              if(this.typeContent!=2){
                this.arbolDocumentador = datosArbol;
                this.arbolDocumentadorSecond = datosArbol_50mas;
              }else{
                this.arbolDocumentador = datosArbolBetter;
                this.arbolDocumentadorSecond = datosArbol_50masBetter;
              }
            }else{
              this.arbolDocumentador = datosArbol;
              this.arbolDocumentadorSecond = datosArbol_50mas;
            }            
            throw BreakException;
          }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      this.getColaboradoresFast();
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }
  
info:any;
getColaboradoresFast(){
  this.wizardService.getColaboradoresFast(this.productoCertificar.fechaNorma35, this.productoCertificar.idNorma35)
  .subscribe( (getFast: colabInter.getBDFast) => {

    if(getFast.message == 'Success' && getFast.numeroColaboradores > 0){
      if(getFast.numeroColaboradores<=50){
        this.statusEncuesta=false;
        this.arrayMenu();
      }else{
        
        this.statusEncuesta=true;
        this.arrayMenuSecond();
      }
    }else{

      this.colaboradoresService.getColaboradoresFast(this.productoCertificar.fechaNorma35, this.productoCertificar.idNorma35)
        .subscribe( (getFast: colabInter.getBDFast) => { 
          this.info=this.colaboradoresService.getinfo();
          this.info.totalColaboradores;
          if(this.info.level==6){
            if(this.info.totalColaboradores>0){
              if(getFast.numeroColaboradores>50){
            // El index 1 es encuesta de 16 a 50
                this.statusEncuesta=false;
                this.arrayMenu();
              }else{
                //El index 2 es el de más de 50
                this.statusEncuesta=true;
                this.arrayMenuSecond();
              }
            }
          }
      });
    }
  });
}


arrayMenu(){
  var StatusStep:number;
  for (var i = 0; i < this.arbolDocumentador.length; i++) {
    if(this.arbolDocumentador[i].name== 'WIZARD.TITLEOBLI'){
      this.ArrayMenu=this.arbolDocumentador[i].children;
        for (var k = 0; k < this.ArrayMenu.length; k++) {
          if(this.ArrayMenu[k].name=="WIZARD.MENU_GUIA.MENU.MN12.TITULO"){
            this.ArrayMenu_Child=this.ArrayMenu[k].children;
            for(let j=0; j<this.ArrayMenu_Child.length;j++){
              this.sendInfoTable(this.ArrayMenu_Child[j].seccion,i,k,j);
            }
          }
        
          this.sendInfoTable(this.ArrayMenu[k].seccion,i,k,10);
        }
    }
  }
}

  arrayMenuSecond(){
    var StatusStep:number;
    for (var i = 0; i < this.arbolDocumentadorSecond.length; i++) {
      if(this.arbolDocumentadorSecond[i].name== 'WIZARD.TITLEOBLI'){
        this.ArrayMenu=this.arbolDocumentadorSecond[i].children;
        for (var k = 0; k < this.ArrayMenu.length; k++) {
          if(this.ArrayMenu[k].name=="WIZARD.MENU_GUIA.MENU.MN12.TITULO"){
           
            this.ArrayMenu_Child=this.ArrayMenu[k].children;
            for(let j=0; j<this.ArrayMenu_Child.length;j++){
              
              this.sendInfoTableSecond(this.ArrayMenu_Child[j].seccion,i,k,j);
            }
          }

          this.sendInfoTableSecond(this.ArrayMenu[k].seccion,i,k,10);
        }
      }
    }
  }


  private sendInfoTable(tittle,pos1,pos2,pos3){
    var Status:number;
    this.fechaDocumentador_P = 2019;
    let i:0;
    this.idiomasService.getStepsData(this.productoCertificar.fechaNorma35).subscribe(( data:any )=>{
  
      
     
      if(data.message=="Success"){
        //let statusTmp=this.cambiarStatusTmp(data.secciones[11].tareasSecundarias,pos3);
        /*if(statusTmp==1){
          //console.log("Entro");
          this.arbolDocumentador[0].status=3;
        }else{
          this.arbolDocumentador[0].status=2;
        }*/
        //console.log(this.arbolDocumentador[0]);
        for(i=0; i<data.secciones.length; i++){
          if(data.secciones[i].nombreSeccion==tittle){
            if(pos3==10){
              Status=this.cambiarStatus(data.secciones[i].tareasSecundarias,10);
            }else{
              Status=this.cambiarStatus(data.secciones[i].tareasSecundarias,pos3);
            }
            // Si es status retorna 1 es que cumple todas las tareas
            if(Status==1){
              // Como cumple todas las tareas el status es igual a 3 porque esta completo
              if(pos3==10){
                this.arbolDocumentador[pos1].children[pos2].status=3;
              }else{
                this.arbolDocumentador[pos1].children[pos2].children[pos3].status=3;
              }
            }else{
              if(pos3==10){
                this.arbolDocumentador[pos1].children[pos2].status=2;
              }else{
                this.arbolDocumentador[pos1].children[pos2].children[pos3].status=2;
              }
            }
            this.treeControl = new FlatTreeControl<ExampleFlatNode>(
              node => node.level, node => node.expandable);
              this.treeFlattener = new MatTreeFlattener(
                this._transformer, node => node.level, node => node.expandable, node => node.children);
                this.dataSourceTree = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
                this.dataSourceTree.data = this.arbolDocumentador;
                
              } // Fin
            }// For
            this.arbolCargado = true;
          }// Data success
        });
  }

  private sendInfoTableSecond(tittle,pos1,pos2,pos3){
  
    var Status:number;
    this.fechaDocumentador_P = 2019;
    let i:0;
    this.idiomasService.getStepsData(this.productoCertificar.fechaNorma35).subscribe(( data:any )=>{
      if(data.message=="Success"){
        //let statusTmp=this.cambiarStatusTmp(data.secciones[11].tareasSecundarias,pos3);
        /*if(statusTmp==1){
          this.arbolDocumentadorSecond[0].status=3;
        }else{
          this.arbolDocumentadorSecond[0].status=2;
        }*/
     
     
        for(i=0; i<data.secciones.length; i++){
          if(data.secciones[i].nombreSeccion==tittle){
           
            if(pos3==10){
              Status=this.cambiarStatus(data.secciones[i].tareasSecundarias,10);
            }else{

              Status=this.cambiarStatus(data.secciones[i].tareasSecundarias,pos3);
            }
            // Si es status retorna 1 es que cumple todas las tareas
            if(Status==1){
              // Como cumple todas las tareas el status es igual a 3 porque esta completo
              if(pos3==10){
                this.arbolDocumentadorSecond[pos1].children[pos2].status=3;
              }else{
                this.arbolDocumentadorSecond[pos1].children[pos2].children[pos3].status=3;
              }
            }else{
              if(pos3==10){
                this.arbolDocumentadorSecond[pos1].children[pos2].status=2;
              }else{
                this.arbolDocumentadorSecond[pos1].children[pos2].children[pos3].status=2;
              }
            }
            this.treeControl = new FlatTreeControl<ExampleFlatNode>(
              node => node.level, node => node.expandable);
              this.treeFlattener = new MatTreeFlattener(
                this._transformer, node => node.level, node => node.expandable, node => node.children);
                this.dataSourceTree = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
                this.dataSourceTree.data = this.arbolDocumentadorSecond;
         
              }
            }
            this.arbolCargado = true;
          }
        });
  }
  private cambiarStatusTmp(array,pos3){
    var  NumStatus:number;
    var ChangeStatus:number;
    var StatusTep: number;
    NumStatus=array.length;
    ChangeStatus=0;
      if(array.length>=1){
        // RECORRER EL ARREGLO Y ASIGNA 1 A CHANGESTATUS PARA POSTERIOEMENTE COMPROBAR QUE SON IGUALES
        for(let i=0; i<array.length; i++){
          if(array[i].estatus=="Cumple" || array[i].estatus=="No aplica"){
            ChangeStatus=ChangeStatus+1;
          }
        }
      }
      // SI EL NUMERO DE NUMSTATUS Y CHANGESTATUS ES IGUAL ES PORQUE CUMPLIO CON TODAS LAS TAREAS
      if(NumStatus == ChangeStatus){
        StatusTep=1;
        if(NumStatus == 0 && ChangeStatus == 0){
          StatusTep=2;
        }
      }else{
            StatusTep=2;
      }
      // 1 es coimpleto / 2 no esta completo
      return StatusTep;
  }

 private cambiarStatus(array,pos3){
  var  NumStatus:number;
  var ChangeStatus:number;
  var StatusTep: number;
  NumStatus=array.length;
  ChangeStatus=0;

    if(array.length>=1){
      // RECORRER EL ARREGLO Y ASIGNA 1 A CHANGESTATUS PARA POSTERIOEMENTE COMPROBAR QUE SON IGUALES
      for(let i=0; i<array.length; i++){
        if(array[i].estatus=="Cumple" || array[i].estatus=="No aplica"){
          ChangeStatus=ChangeStatus+1;
        }
      }

    }
    // SI EL NUMERO DE NUMSTATUS Y CHANGESTATUS ES IGUAL ES PORQUE CUMPLIO CON TODAS LAS TAREAS
    if(NumStatus == ChangeStatus){
      StatusTep=1;
      if(NumStatus == 0 && ChangeStatus == 0){
        StatusTep=2;
      }
    }else{
          StatusTep=2;
    }
    // 1 es coimpleto / 2 no esta completo
    return StatusTep;
  }

  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      ruta: node.ruta,
      status:node.status,
      pos:node.pos,
      level: level,
    };
  }





}
